// extracted by mini-css-extract-plugin
export var container = "MobileHeader-module--container--5538a";